import { ListData } from '@fi-app/components/items-list/list-data.service';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { CentralBillingUnitModuleModel } from './central-billing-unit-module.model';
import { Injector } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export class BillingCentralListData extends ListData<CentralBillingUnitModuleModel> {
    constructor(injector: Injector) {
        super(injector, true, 'ModuleTypeName');

        this.ShowDelete = false;

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.module'),
                'ModuleTypeName',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: FiStateNames.Billing.Central.View,
                    SrefParams: (data) => ({ ModuleType: data.ModuleType }),
                }),
            ),
        );

        this.addSpanPlainHeader(this.appTextService.get('default_status'), 'IsEnabledText');

        this.addSpanPlainHeader(this.appTextService.get('billing.billing'), 'BillingTypeName');

        this.addSpanPlainHeader(this.appTextService.get('billing.central_billing_level'), 'PackageTypeName');
    }
}
